__webpack_require__.p = "/React-TurkishCheckers/";